module.exports = __webpack_public_path__ + "img/bread-account-center-deliver.8eb3a9a3.png";